import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerList: [],
  customerExtendedFormList: [],
  customerDetail: [],
  loading: false,
  error: undefined,
};

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchCustomerList(state, action) {
      state.customerList = action.payload;
      state.loading = false;
    },
    fetchCustomerExtendedFormList(state, action) {
      state.customerExtendedFormList = action.payload;
      state.loading = false;
    },
    fetchCustomerDetail(state, action) {
      state.customerDetail = action.payload;
      state.loading = false;
    },
  },
});

export const customerActions = customerSlice.actions;

export default customerSlice.reducer;
